import {
  OpticalPort,
  PortCombo,
  ProbePad,
  RawOpticalPort,
  RawPortCombo,
  RawProbePad,
  RawReferenceWaveguide,
  RawStructure,
  ReferenceWaveguide,
  Structure,
} from "@/types/designs";
import { RawStructureSummary, StructureSummary } from "@/types/structure";

const mapRawToOpticalPort = (raw: RawOpticalPort): OpticalPort => {
  return {
    cellPort: raw.cell_port,
    id: raw.id,
    name: raw.name,
    orientation: raw.orientation,
    structureId: raw.structure_id,
    tag: raw.tag,
    x: raw.x,
    y: raw.y,
  };
};

const mapRawToReferenceWaveguide = (raw: RawReferenceWaveguide): ReferenceWaveguide => {
  return {
    id: raw.id,
    refWaveguideId: raw.ref_waveguide_id,
    structureId: raw.structure_id,
  };
};

const mapRawToProbePad = (raw: RawProbePad): ProbePad => {
  return {
    id: raw.id,
    name: raw.name,
    orientation: raw.orientation,
    structureId: raw.structure_id,
    x: raw.x,
    y: raw.y,
  };
};

const mapRawToPortCombo = (raw: RawPortCombo): PortCombo => {
  return {
    alignAtPeak: raw.align_at_peak,
    alignPwrRng: raw.align_pwr_rng,
    blindStep: raw.blind_step,
    dynamicAlignment: raw.dynamic_alignment,
    id: raw.id,
    index: raw.index,
    inputs: raw.inputs,
    measurePwrRng: raw.measure_pwr_rng,
    name: raw.name,
    outputs: raw.outputs,
    pads: raw.pads,
    probeCheck: raw.probe_check,
    refWg: raw.ref_wg,
    settings: raw.settings,
    structureId: raw.structure_id,
    zMargin: raw.z_margin,
  };
};

export const mapRawToDesign = (raw: RawStructure): Structure => {
  return {
    deviceClass: raw.device_class,
    id: raw.id,
    isReferenceWaveguide: raw.is_reference_waveguide,
    name: raw.name,
    isCustom: raw.is_custom,
    opticalPorts: raw.optical_ports.map(mapRawToOpticalPort),
    portCombos: raw.port_combos.map(mapRawToPortCombo),
    probePads: raw.probe_pads.map(mapRawToProbePad),
    refWaveguides: raw.ref_waveguides.map(mapRawToReferenceWaveguide),
    testSiteName: raw.test_site_name,
    hasTestLabels: raw.test_labels.length > 0,
  };
};

export const mapRawToStructureSummary = (raw: RawStructureSummary): StructureSummary => {
  return {
    id: raw.id,
    name: raw.name,
    isCustom: raw.is_custom,
    canDelete: raw.can_delete,
    testSiteName: raw.test_site_name,
  };
};
